// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"943c271f","391":"247e03e5","477":"6a7d4452","698":"f927277b","901":"4a119391"}[chunkId] + ".chunk.js";
};